export const SAVE_BUTTON_CLICK = 'substanceDetailHeader/SAVE_BUTTON_CLICK';
export const CANCEL_BUTTON_CLICK = 'substanceDetailHeader/CANCEL_BUTTON_CLICK';
